import { useEffect, useRef, useState } from "react";
import useTabActive from "src/hooks/use-tab-active";
import { getBaseWsUrl } from "../utils/url";
import { useAuth } from "../components/providers/auth-context";

const useWebsockets = (onMessage) => {
    const tabActive = useTabActive();
    const [wss, setSocketClient] = useState(null);
    const [errorPaused, setErrorPaused] = useState(false);
    const { jwt, isDemo, user } = useAuth();

    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = onMessage;
    }, [onMessage]);

    const connect = () => {
        if (wss || errorPaused || !tabActive) return;
        const client = new WebSocket(`${getBaseWsUrl()}/notifications-ws`, [
            "authorization",
            jwt.raw,
        ]);
        client.onopen = () => {
            setErrorPaused(false);
            client.send(JSON.stringify({ type: "notifications" }));
        };
        client.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (savedCallback.current) {
                // @ts-ignore
                savedCallback.current(data);
            }
        };
        client.onclose = () => {
            setSocketClient(null);
        };

        // eslint-disable-next-line no-unused-vars
        client.onerror = (_e) => {
            client.close();
            setErrorPaused(true);
        };

        setSocketClient(client);
    };

    useEffect(() => {
        if (jwt && jwt.raw && errorPaused) {
            setErrorPaused(false);
        }
    }, [jwt && jwt.raw]);

    useEffect(() => {
        if (
            jwt &&
            user &&
            !isDemo &&
            !wss &&
            tabActive &&
            ["prod", "sit"].includes(process.env.ENVIRONMENT_NAME)
        ) {
            connect();
        }
    }, [jwt, user, isDemo, wss, tabActive]);

    useEffect(() => {
        return () => {
            if (wss) {
                wss.close();
            }
        };
    }, []);
};

export default useWebsockets;
